var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.111,
    height: 23.111,
    viewBox: "0 0 23.111 23.111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Broken_Search",
    "data-name": "Iconly/Broken/Search",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search",
    transform: "translate(1.926 1.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Search-2",
    "data-name": "Search",
    d: "M19.024,17.917l-3.31-3.236h0l-.078-.118a.779.779,0,0,0-1.095,0h0a7.812,7.812,0,0,1-10.129.328A7.4,7.4,0,0,1,2.769,5.113a7.776,7.776,0,0,1,9.7-2.858,7.455,7.455,0,0,1,4.154,9.038.75.75,0,0,0,.175.743.791.791,0,0,0,.746.223.773.773,0,0,0,.571-.52h0A8.988,8.988,0,0,0,13.3.906,9.393,9.393,0,0,0,1.626,3.934,8.913,8.913,0,0,0,2.936,15.676a9.426,9.426,0,0,0,12.071.5l2.931,2.865a.788.788,0,0,0,1.095,0,.755.755,0,0,0,0-1.079h0Z",
    transform: "translate(0 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSearchIcon);
export default __webpack_public_path__ + "static/media/menu_searchIcon.523d805dd05f325b3b8294f7afdc35db.svg";
export { ForwardRef as ReactComponent };